import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { getWindowOrThrow } from "@faire/web--source/common/globals/getWindow";
import { throttleIfPossible } from "@faire/web--source/common/globals/throttleIfPossible";
import { getOverride } from "@faire/web--source/common/PublicSettings";
import { singletonGetter } from "@faire/web--source/common/singletons/getter";
import once from "lodash/once";
import { BATCH_SETTING_THROTTLE_MS, sharedAssignSetting, unthrottledBatchAssignSetting } from "./sharedAssignSetting";
import { sharedGetSetting } from "./sharedGetSetting";
/**
 * Needs to be a singleton store for SSR.
 * @deprecated Use createSettingsContextProvider instead.
 */ export var SerializedSettingCache = function SerializedSettingCache() {
    "use strict";
    var _this = this;
    _class_call_check(this, SerializedSettingCache);
    var _this1 = this;
    this._assignmentCache = new Set();
    this._onUnloadListener = once(function() {
        try {
            getWindowOrThrow().addEventListener("visibilitychange", function(e) {
                var _e_target;
                if ("flush" in legacyThrottledBatchAssignSetting && ((_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.visibilityState) === "hidden") {
                    legacyThrottledBatchAssignSetting.flush();
                }
            });
        } catch (_) {
        /* silence, handle if window is not defined */ }
    });
    this.clear = function() {
        _this._assignmentCache.clear();
        _this._assignmentAccumulator.clear();
    };
    this._assignmentAccumulator = new Map();
    this.assignSetting = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(settingOrKey, options) {
            return _ts_generator(this, function(_state) {
                _this1._onUnloadListener();
                return [
                    2,
                    sharedAssignSetting(settingOrKey, options, _this1._assignmentCache, _this1._assignmentAccumulator, legacyThrottledBatchAssignSetting)
                ];
            });
        });
        return function(settingOrKey, options) {
            return _ref.apply(this, arguments);
        };
    }();
};
SerializedSettingCache.get = singletonGetter(SerializedSettingCache);
/**
 * Creates the getSetting function associated with a specific Realm, i.e. Brand, Retailer, Admin, etc.
 * @param pageSerializedData
 * @deprecated Use createSettingsContextProvider instead.
 */ export var getSettingFactory = function(pageSerializedData) {
    var getSettingValueWithoutAssignment = function getSettingValueWithoutAssignment(settingOrKey, defaultValue) {
        var pageData = pageSerializedData();
        var key = typeof settingOrKey === "string" ? settingOrKey : settingOrKey.name;
        var overrideSettingValue = getOverride(key);
        return sharedGetSetting(settingOrKey, pageData, overrideSettingValue, defaultValue);
    };
    var getSettingValueAndAssign = function getSettingValueAndAssign(settingOrKey, defaultValue) {
        SerializedSettingCache.get().assignSetting(settingOrKey);
        return getSettingValueWithoutAssignment(settingOrKey, defaultValue);
    };
    return {
        getSettingValueWithoutAssignment: getSettingValueWithoutAssignment,
        getSettingValueAndAssign: getSettingValueAndAssign,
        assignSetting: SerializedSettingCache.get().assignSetting
    };
};
/**
 * @deprecated Use the hooks implementation instead.
 */ export var legacyThrottledBatchAssignSetting = throttleIfPossible(unthrottledBatchAssignSetting, BATCH_SETTING_THROTTLE_MS, {
    leading: false
});
